var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"content-tile",attrs:{"href":_vm.content.link,"rel":"noopener"}},[_c('div',{staticClass:"content-tile__image-wrapper"},[_c('img',{staticClass:"content-tile__image",attrs:{"src":_vm.content.image,"alt":_vm.content.title}})]),_vm._v(" "),_c('div',{staticClass:"content-tile__title"},[_c('span',{staticClass:"arrow"},[_vm._v("→")]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.content.title)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/ContentTile.vue